<style scoped lang="scss">
.adv-list {
  .lists {
    flex-wrap: wrap;
    li {
      flex: auto;
      margin-top: 10px;
      img {
        height: 60px;
      }
      h4 {
        margin-top: 20px;
        font-size: 16px;
      }
      p {
        white-space: pre-line;
        line-height: 1.6;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .adv-list .lists li {
    width: 100% !important;
    margin: 20px 0 !important;
  }
}
</style>
<template>
  <div class="adv-list container">
    <div class="desc">擎科生物依托基因合成全产业链优势、实现高交付率、高准确率，提供免费载体库和免费密码子优化。</div>
    <ul class="lists">
      <li
        v-for="(item, index) in advantagesList"
        :key="index"
        :style="{
          width: item.width ? item.width : 100 / (advantagesList.length / lines) + '%',
          marginTop: lines > 1 && index + 1 > advantagesList.length / lines ? '60px' : '10px',
        }"
      >
        <img
          :src="require(`@/assets/images/${item.img}.png`)"
          :alt="`擎科生物-${menuTitle}产品优势-${item.title}`"
        />
        <h4>{{ item.title }}</h4>
        <p v-if="item.text">{{ item.text }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "gene-advantages",
  props: {
    lines: {
      type: Number,
      default: 1,
    },
    advantagesList: {
      type: Array,
    },
    menuTitle: {
      type: String,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/gene-components/geneAdvantages.vue